import { getCurrentDate, getCurrentYear } from '@/helpers/currentDate';
import { getOriginUrl } from '@/helpers/currentUrl';

export const usingLanguagesForCitationExhibit = ['RU', 'ENG'];

function getTextOfExhibitCitationInRu(barcode, id) {
  return `Образец ${barcode} [Электронный ресурс] // Цифровой гербарий Самарского университета (SMR). Самара: Самарский университет,
        ${getCurrentYear()}. Режим доступа: ${getOriginUrl()}/collections/${id} (дата обращения:
        ${getCurrentDate()}).`;
}

function getTextOfExhibitCitationInEng(barcode, id) {
  return `Specimen ${barcode} [Electronic resource] // Digital Herbarium of Samara University (SMR). Samara: Samara University,
        ${getCurrentYear()}. Available at: ${getOriginUrl()}/collections/${id} (accessed:
        ${getCurrentDate()}).`;
}

export function getTextOfExhibitCitationByLanguage(barcode, id, lang = 'RU') {
  let targetText = '';

  switch (lang) {
    case 'RU':
      targetText = getTextOfExhibitCitationInRu(barcode, id);
      break;
    case 'ENG':
      targetText = getTextOfExhibitCitationInEng(barcode, id);
      break;
    default:
      targetText = getTextOfExhibitCitationInRu(barcode, id);
  }

  return targetText;
}